import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [stores, setStores] = useState([]);
  const [currentStoreId, setCurrentStoreId] = useState(() => localStorage.getItem("pos_store_id") || "");

  useEffect(() => {
    const token = localStorage.getItem("pos_token");
    if (!token) {
      setUser(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  useEffect(() => {
    if (user && user.id) {
      api.get("/stores").then((r) => {
        const list = r.data || [];
        setStores(list);
        // Reset selection if empty OR pointing at a store that no longer exists
        const valid = list.some((s) => s.id === currentStoreId);
        if (!valid && list.length > 0) {
          setCurrentStoreId(list[0].id);
          localStorage.setItem("pos_store_id", list[0].id);
        }
      }).catch(() => {});
    }
  }, [user]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("pos_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch(e) {}
    localStorage.removeItem("pos_token");
    localStorage.removeItem("pos_store_id");
    setUser(false);
  };

  const switchStore = (id) => {
    setCurrentStoreId(id);
    localStorage.setItem("pos_store_id", id);
  };

  const refreshStores = async () => {
    const r = await api.get("/stores");
    setStores(r.data || []);
    return r.data;
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, stores, setStores, currentStoreId, switchStore, login, logout, refreshStores }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
